import { Injectable } from '@angular/core';
import { IPaymentSource } from '@core/interfaces/payment/payment-source.interface';
import { Observable, of } from 'rxjs';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { IPayment } from '@core/interfaces/payment/payment.interface';
import { delay } from 'rxjs/operators';
import { PAYMENT_METHOD_LIST } from '@core/mocks/payment/payment-method.mock';

@Injectable()
export class PaymentSourceMockService implements IPaymentSource {

  counter = 0;

  getPaymentMethods(): Observable<IListResult<IPayment>> {
    return of(PAYMENT_METHOD_LIST).pipe(delay(1000));
  }

}
